export default __webpack_public_path__ + "static/d767f672-91c7-4561-bd5a-9f5981f3b33d-6199c18c4b2c5fe6fbf9a90d4c45c524.jpg";